import type { InputHTMLAttributes } from 'react'
import { cn } from '@/shared/lib'
import { Icon } from '@/shared/ui/icon'

type SearchInputProps = InputHTMLAttributes<HTMLInputElement>

export function SearchInput({ className, ...rest }: SearchInputProps) {
  return (
    <div className={cn('relative', className)}>
      <Icon
        name="search"
        size={17}
        className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-faint"
      />
      <input
        type="search"
        className="h-11 w-full rounded-full border border-transparent bg-raise pl-11 pr-4 text-body-sm text-app-fg placeholder:text-faint transition-colors focus:border-outline focus:outline-none"
        {...rest}
      />
    </div>
  )
}
